import type { SwitchFieldConfig } from '../../config';
import type { SectionKey } from '../../lease-details.types';
import { LeaseSwitchInput } from '../../inputs/lease-switch-input';
import { useFieldEventContextBuilder } from '../use-field-event-context';

export type SwitchFieldProps = {
  path: string;
  field: SwitchFieldConfig;
  sectionKey: SectionKey;
  arrayIndex?: number;
  disabled: boolean;
};

export const SwitchField = ({
  path,
  field,
  sectionKey,
  arrayIndex,
  disabled,
}: SwitchFieldProps) => {
  const buildContext = useFieldEventContextBuilder<boolean>(path, sectionKey, arrayIndex);
  return (
    <LeaseSwitchInput
      name={path}
      label={field.label}
      disabled={disabled}
      onChangeValue={
        field.events?.onChange
          ? (checked) => field.events?.onChange?.(buildContext(checked))
          : undefined
      }
    />
  );
};
